import React from 'react';
import { useQuery } from 'react-query';
import * as DOMPurify from 'dompurify';
import { AirplanemodeInactive as AirplanemodeInactiveIcon } from '@mui/icons-material';
import API from '@wheeebo/polaris-api';
import { Palette } from './Palette';
import PlaceMarker from './PlaceMarker';
function NoFlyZoneMarker({ noFlyZoneId, position, ...props }) {
    const [content, setContent] = React.useState();
    const [open, setOpen] = React.useState(false);
    const { data } = useQuery(API.NoFlyZones.getKey(noFlyZoneId), () => API.NoFlyZones.get(noFlyZoneId), {
        enabled: open,
    });
    const handleClick = React.useCallback(() => setOpen((e) => !e), []);
    React.useEffect(() => {
        DOMPurify.setConfig({ ALLOWED_TAGS: [] });
        const lat = typeof position?.lat === 'function' ? position.lat() : position?.lat || 0;
        const lng = typeof position?.lng === 'function' ? position.lng() : position?.lng || 0;
        const lines = [
            `<div style="padding-top: 0.25rem; padding-bottom: 0.25rem;">
        <span style="border-radius: 3px; border: 1px solid #888; padding: 0.15rem 0.75rem; font-size: 0.65rem">
        No-fly Zone</span>
      </div>
      <h2 style="margin-top: 0.5rem; margin-bottom: 0.5rem">${DOMPurify.sanitize(data?.name || '')}</h2>
      <div style="white-space: pre">${`${lat.toFixed(6)}   ${lng.toFixed(6)}`}</div>
      <div style="padding-top: 1rem"><table>
      </table></div>`,
        ];
        setContent(lines.join(''));
    }, [data, position]);
    return (React.createElement(PlaceMarker, { position: position, ...props, color: Palette.NoFlyZoneMarker, muiIcon: React.createElement(AirplanemodeInactiveIcon, null), popupContent: content, onClick: handleClick }));
}
export default React.memo(NoFlyZoneMarker);
